declare global {
  interface Window {
    fbq: (
      command: string,
      eventName: string,
      options?: Record<string, unknown>
    ) => void;
  }
}

export const fbPixel = {
  track: (eventName: string, options = {}) => {
    if (window.fbq) {
      window.fbq('track', eventName, options);
    }
  },
  
  trackCustom: (eventName: string, options = {}) => {
    if (window.fbq) {
      window.fbq('trackCustom', eventName, options);
    }
  }
};
